
import React, { useState, useContext, useEffect } from 'react';
import '../../../styles/casedetails.css';
import { Outlet, Link, useNavigate, Navigate } from 'react-router-dom';
import { ShareContext } from '../../../context/ShareContext'
import * as Constants from '../../../constants';
import JisButton from '../../controls/jisButton';

function ViewCaseInfo({caseId,caseinfo=null, isAction=false}) {
      const {  activePage, token, profile,frequentData, setIsExpired} = useContext(ShareContext);
      const [fiats, setFiats] = useState([]);
      const [loading, setLoading] =useState(false);
      const [cinfo, setCaseInfo] = useState(caseinfo);

         const onLoad= async()=>{
            //for account registration
            try {
              setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/filing/case-details/${caseId}/caseinfo`, { 
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                  },
                });
                
                const data = await resp.json();
                if(data.code==0){
                  setCaseInfo(data.caseinfo);
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
               
               
              } catch (error) {
                setLoading(false);
                console.error(error);
                
              }
        }
  return (
    <div>
  {isAction && <div style={{textAlign:'right'}}><JisButton>Upload FIAT (if Applicable)</JisButton></div>} 
       <section class="case-info">
        <div className="summary">
          <div><strong>Parties to the Case</strong><br />{caseinfo?.caseTitle}</div>
          <div><strong>Suite Number</strong><br />{caseinfo?.caseNumber}</div>
          <div><strong>Case of Origin</strong><br />{Constants.getItemById(frequentData?.caseorigin,caseinfo?.caseOriginId)?.title} </div>
          <div><strong>Division</strong><br />{Constants.getItemById(frequentData?.divisions,caseinfo?.divisionId)?.title}  </div>
          <div><strong>Classification</strong><br /> {Constants.getItemById(frequentData?.casecategories,caseinfo?.caseCategoryId)?.categoryTitle}</div>
          <div><strong>Date Filed</strong><br />{Constants.momentDate(caseinfo?.createdOn).format('DD MMM, YYYY')} </div>
          <div><strong>Case Type</strong><br />{Constants.getItemById(frequentData?.casetype,caseinfo?.caseTypeId)?.caseType1} </div>
          <div><strong>Case Status</strong><br />{Constants.getItemById(frequentData?.casestatuses,caseinfo?.caseStatusId)?.description} </div>
          <div><strong>Filing Type</strong><br />{Constants.getItemById(frequentData?.filingtypes,caseinfo?.caseFilingId)?.title} </div>
          <div><strong>Process Mode</strong><br />{caseinfo?.processType}</div>
         {caseinfo?.orderStatus!=null && <div><strong>Judgement Status</strong><br />{caseinfo?.orderStatus}</div>} 
         {caseinfo?.concludedOn!=null && <div><strong>Judgement Date</strong><br /> {Constants.momentDate(caseinfo?.concludedOn).format('DD MMM, YYYY')}</div>} 
          
        </div>
 <hr/>
      <div className="wide"> 
            <div>
              <h3>Cause of Actions</h3>
              <div style={{display:'flex'}}>
                {caseinfo?.causes?.map((opt) => (
                      <div key={opt.id}  className='selected'>
                        <strong >{opt.description}</strong>
                        </div>                      
                ))}
              </div>
               
            </div>
            </div>
      </section>


      <div  className='table'>
        <div class="section-cases">
          <span>Claims Details</span>
        </div>
        <table className='case-table'>
          <thead>
            <tr>
              <th>Claim/Offence Description</th>
              <th>Claim/Offence Value</th>
              <th>Claim Type</th>
            </tr>
          </thead>
          <tbody>
            {caseinfo?.claims.map((opt) => ( 
                 <tr  key={opt.id}>
              <td>{opt.claim}</td>
              <td>
                <strong>{opt.currencyType}</strong> {Constants.formatCurrency(opt.claimValue) }
              </td>
              <td>{opt.type}</td>
            </tr>               
            ))}
            
          </tbody>
        </table>
      </div>
    
       <div  className='table'>
        <div class="section-cases">
          <span>Legal Counsel</span>
        </div>
        <table className='case-table'>
           <thead>
            <tr>
              <th>First name</th>
              <th>Last Name</th>
              <th>Phone</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
           {caseinfo?.legalcounsels?.map((opt, ind) => (
       <tr key={ind}>
        <td>{opt.firstName}</td>
      <td>{opt.lastName??''}</td>
     <td>{opt.primaryContactNumber}</td>
     <td>{opt.primaryEmail}</td>
    </tr>
    ))} 
          </tbody>
        </table>
      </div>
 {caseinfo?.fiats?.length>0 && <div  className='table'>
        <div class="section-cases">
          <span>FIAT</span>
        </div>
         <table class="case-table">
  <thead>
    <tr>

      <th>Legal Counsel</th>
      <th>Date Filed</th>
      <th>Approval Status</th>
      <th>Allow Payment</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
     {caseinfo?.fiats?.map((opt, ind) => (
       <tr key={ind}>
    
      <th>{opt?.legalCounsel.firstName} {opt?.legalCounsel.lastName??""}</th>
      <td>{ Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</td>
      <td>{opt.isApproved==null?'pending':(opt?.isApproved?'Approved':'Rejected')}</td>
      <td>{opt.isApproved==null?'pending':(opt?.isPay && opt?.isApproved?'Zero Payment':'Payment Required')}</td>
      <td></td>
    </tr>
    ))} 
    


  </tbody>
</table>
      </div>} 

 {caseinfo?.presessions?.length>0 && <div  className='table'>
        <div class="section-cases">
          <span>Pre-Session Meeting</span>
        </div>
         <table class="case-table">
  <thead>
    <tr>

      <th>Pre Session Date</th>
      <th>Tentative Dates</th>
      <th>Selected Date</th>
      
      <th>Created on</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
     {caseinfo?.presessions?.map((opt, ind) => (
       <tr key={ind}>
    
      <th>{opt?.preDate} </th>
      <td>{ opt?.availableDates}</td>
      <td>{opt.dateSelected==null?'pending':opt.dateSelected}</td>
      <td>{opt.createdOn}</td>
      <td></td>
    </tr>
    ))} 
  </tbody>
</table>
      </div>}  

{caseinfo?.mediations?.length>0 && <div  className='table'>
        <div class="section-cases">
          <span>Mediation Meeting</span>
        </div>
         <table class="case-table">
  <thead>
    <tr>

      <th>Mediation Date</th>
      <th>Parties Settled</th>
      <th>Summary</th>
      
      <th>Created on</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
     {caseinfo?.mediations?.map((opt, ind) => (
       <tr key={ind}>
    
      <th>{opt?.mediationDate} </th>
      <td>{opt.partiesSettled==null?'pending':(opt?.partiesSettled?'Settled':'not Settled')}</td>
      <td>{opt.summary}</td>
      <td>{opt.createdOn}</td>
      <td></td>
    </tr>
    ))} 
  </tbody>
</table>
      </div>} 
    </div>
  );
}

export default ViewCaseInfo;